import * as React from 'react';
import cn from 'clsx';
import * as styles from './styles.css';

import { Button, Input, MaskedInput, InputAdornment } from '@cian/ui-kit';

import { NBSP } from '../../../constants/symbols';

import error from './icons/error.svg';
import { getMask } from './utils';
import { Text } from '../../Text';
import { IFeedbackFormContainerState, TFeedbackFields } from '../../../containers/FeedbackFormContainer';

export interface IFormProps extends IFeedbackFormContainerState {
  isLoading: boolean;
  isSendError: boolean;
  setField(value: string, field: TFeedbackFields): void;
  sendForm(e: React.FormEvent): void;
}

export function Form({
  name,
  phone,
  email,
  comment,
  nameError,
  phoneError,
  emailError,
  commentError,
  setField,
  sendForm,
  isLoading,
  isSendError,
}: IFormProps) {
  return (
    <form action="#" className={styles['form']} onSubmit={sendForm}>
      <div className={cn(styles['row'], styles['inputs'])}>
        <div className={styles['field']}>
          <Input
            placeholder="Ваше имя*"
            value={name}
            invalid={nameError}
            onChange={(_, value) => setField(value, 'name')}
            size="M"
            rightAdornment={
              nameError && (
                <InputAdornment>
                  <img src={error} width="16" height="16" alt="" />
                </InputAdornment>
              )
            }
          />
        </div>
        <div className={styles['field']}>
          <Input
            value={email}
            onChange={(_, value) => setField(value, 'email')}
            placeholder="Email*"
            invalid={emailError}
            size="M"
            rightAdornment={
              emailError && (
                <InputAdornment>
                  <img src={error} width="16" height="16" alt="" />
                </InputAdornment>
              )
            }
          />
        </div>
        <div className={styles['field']}>
          <MaskedInput
            mask={getMask(phone)}
            value={phone}
            placeholder="Мобильный телефон*"
            invalid={phoneError}
            onChange={value => setField(value, 'phone')}
            size="M"
            rightAdornment={
              phoneError && (
                <InputAdornment>
                  <img src={error} width="16" height="16" alt="" />
                </InputAdornment>
              )
            }
          />
        </div>
      </div>
      <div className={cn(styles['row'], styles['comment'])}>
        {commentError && <img src={error} alt="" />}
        <textarea
          className={cn(commentError && styles['input-invalid'])}
          placeholder="Комментарий*"
          value={comment}
          onChange={e => setField(e.target.value, 'comment')}
          rows={5}
        />
      </div>
      {isSendError && (
        <div className={styles['error-text']}>
          <Text color="white">Ошибка сервера. Попробуйте еще раз, либо{NBSP}зайдите попозже</Text>
        </div>
      )}
      <div className={cn(styles['row'], styles['feedback-button'])}>
        <Button type="submit" theme="fill_white_secondary" size="M" loading={isLoading}>
          Отправить заявку
        </Button>
        <div />
      </div>
    </form>
  );
}
